import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';
import type { Database } from '../types/supabase';

export type CreateDiscountCodeInput =
  Database['public']['Tables']['discount_codes']['Insert'];

export function useCreateDiscountCode() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateDiscountCodeInput) => {
      const { data: created, error } = await supabase
        .from('discount_codes')
        .insert(data)
        .select()
        .single();

      if (error) throw error;
      return created;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['discount-codes'] });
    },
  });
}
